export default {
  addYourCommentHere: 'Add your comment here',
  addDescriptionToYourTaskToProvideMoreInformationToYourTeam:
    'Add a description to your task to provide more information to your team.',
  accordingToTheRulesForRoundingContractorInvoiceAmountsUpTo001TheAmountMayDifferFromThePaidByAFewCents:
    'According to the rules for rounding contractor invoice amounts up to $0.01, the Amount may differ from the Paid by a few cents.',
  applyToAll: 'Apply to all',
  allFiles: 'All files',
  allInvoiceTagsWillBeUpdated: 'All invoice tags will be updated',
  alreadyAdded: 'Already added',
  areYouSureYouWantToDeleteThisRecordThisActionCannotBeUndone:
    'Are you sure you want to delete this record? This action cannot be undone.',
  areYouSureYouWantToDeleteThisTransactionImports:
    'Are you sure you want to delete this transaction imports?',
  areYouSureThisActionCannotBeUndone:
    'Are you sure? This action cannot be undone.',
  areYouSureYouWantToAbortTheTask: 'Are you sure you want to abort the task?',
  areYouSureYouWantToAbortTheTasks: 'Are you sure you want to abort the tasks?',
  areYouSureYouWantToDeleteTheTask: 'Are you sure you want to delete the task?',
  areYouSureYouWantToUngroup: 'Are you sure you want to ungroup?',
  areYouSureYouWantToRemoveTheseTasks:
    'Are you sure you want to remove these tasks from group?',
  areYouSureYouWantToCancelTheTask: 'Are you sure you want to cancel the task?',
  areYouSureYouWantToCloseTheTask: 'Are you sure you want to close the task?',
  areYouSureYouWantToContinueTheTask:
    'Are you sure you want to continue the task?',
  areYouSureYouWantToCancelCreatingTasks:
    'Are you sure you want to cancel creating tasks?',
  areYouSureYouWantToClearSelected: 'Are you sure you want to clear selected?',
  areYouSureYouWantToCreateMissingWhiteboardShapes:
    'Are you sure you want to create missing whiteboard shapes?',
  areYouSureYouWantToCreateMissingWhiteboardComments:
    'Are you sure you want to create missing whiteboard comments?',
  areYouSureYouWantToCreateMissingWhiteboardImage:
    'Are you sure you want to create missing whiteboard_image?',
  areYouSureYouWantToClearAllFormFields:
    'Are you sure you want to clear all form fields?',
  areYouSureYouWantToDeletTheBillingAddress:
    'Are you sure you want to delete the billing address?',
  areYouSureYouWantToDeleteAccount: 'Are you sure you want to delete account?',
  areYouSureYouWantToDeleteTab: 'Are you sure you want to delete tab?',
  areYouSureYouWantToMuteNotifications:
    'Are you sure you want to mute notifications?',
  areYouSureYouWantToUnmuteNotifications:
    'Are you sure you want to unmute notifications?',
  areYouSureYouWantToBlockThisAccount:
    'Are you sure you want to block this account?',
  areYouSureYouWantToLeaveTheCompanies:
    'Are you sure you want to leave the companies?',
  areYouSureYouWantToJoinThePerformersTeamsOfTheseCompanies:
    'Are you sure you want to join the performers teams of these companies?',
  areYouSureYouWantToDenyAccess: 'Are you sure you want to deny access?',
  areYouSureYouWantToUnblockThisAccount:
    'Are you sure you want to unblock this account?',
  areYouSureYouWantToDeleteThisAccount:
    'Are you sure you want to delete this account? You will lose access to it forever.\n\nIf you are sure, confirm by entering the password below.',
  areYouSureYouWantToDeleteThisThread:
    'Are you sure you want to delete this thread?',
  areYouSureYouWantToDeleteThisTemplate:
    'Are you sure you want to delete this template?',
  areYouSureYouWantToDeletTheField:
    'Are you sure you want to delete the field?',
  areYouSureYouWantToRemoveThisUserFromCompany:
    'Are you sure you want to remove this user from company?',
  areYouSureYouWantToRemoveAllCMsFromTheseCompanies:
    'Are you sure you want to remove all CMs from these companies?',
  areYouSureYouWantToRemoveItemsFromDraft:
    'Are you sure you want to remove this items from draft invoice?',
  areYouSureYouWantToBlockThisCompany:
    'Are you sure you want to block this company? All members will lose access to it.',
  areYouSureYouWantToReplaceActiveWhiteboardWithBackup:
    'Are you sure you want to replace active whiteboard with backup?',
  areYouSureYouWantToDeleteSavedFilterThisActionCannotBeUndone:
    'Are you sure you want to delete saved filter? This action cannot be undone.',
  atLeastOneTaskMustBeEntered: 'At least one task must be entered',
  clearFilters: 'clear filters',
  convertFromMarkdown: 'Convert from markdown',
  contractorPercentagesTotalOver100PleaseAdjust:
    'Contractor percentages total over 100%. Please adjust.',
  changeStudioPage: 'Change studio page',
  changeStudio: 'Change\nstudio',
  collapseAll: 'Collapse all',
  createStudioPage: 'Create studio page',
  createStudio: 'Create\nstudio',
  dropTheFilesHere: 'Drop the files here ...',
  byRatingTasksYouAcceptTaskResultsForTheClient:
    'By rating tasks, you accept task results for the client',
  cancelThisFileToTryAgain: 'Cancel this file to try again',
  changeVisibility: 'Change visibility',
  commentHere: 'Comment here',
  deleteThread: 'Delete thread',
  dragAndDropFilesOr: 'Drag and drop files, or:',
  dragImageHereOrClickToSelect: 'Drag image here or click to select',
  editColumn: 'Edit column',
  extractingMessages: 'Extracting messages',
  fileIsUploading: 'File is uploading...',
  filesInDeepArchive: 'Files in Deep Archive',
  filterByDate: 'Filter by date',
  helpWithTextFormatting: 'Help with text formatting',
  hideColumn: 'Hide column',
  indicateHowMuchDoYouAgreeWithTheFollowingStatement:
    'Please rate the degree to which you agree or disagree with each of the following statements',
  iHaveReadAndAgreeToTheUpdatedInformation:
    'I have read and agree to the updated information',
  noThanks: 'No, thanks',
  mutedThisByAccident: 'Muted this by accident?',
  pleaseConsiderCreatingANewTaskWithFurtherInstructionsOrContactUsAtProjectThreadDirectly:
    'Please consider creating a new task with further instructions or contact us at project thread directly.',
  pleaseProvideYourAddress: 'Please, provide your address',
  pleaseRateTheTask: 'Please, rate the task',
  pleaseRateTaskRusult: 'Please, rate task result',
  pleaseUpdateToTheLatestVersionThisWillRefreshThePage:
    'Please update to the latest version. This will refresh the page.',
  previewTextFormatting: 'Preview text formatting',
  iConfirmThatIHaveReadAndAgreeTo: 'I confirm that I have read and agree to ',
  inviteYourTeamMembers: 'Invite your team members',
  learnAboutItemTypes: 'Learn about item types',
  letsGetToKnowEachOther: "Let's get to know each other",
  acceptTaskResult: 'Accept task result',
  approveTaskResult: 'Approve task results',
  weAreOnline: "We're online 08:00 AM to 05:00 PM GMT Monday-Friday.",
  weAreReadyToHelp:
    "At that time we're ready to help and answer any questions.",
  whiteboardDataHasBeenUpdatedPleaseReloadThePage:
    'Whiteboard data has been updated. Please reload the page.',
  writeHereWarning:
    'The team may not track this task since it has been completed, are you sure you want to leave a message here?',
  selectInvoiceFromTheList: 'Select invoice from the list',
  sendEmailNotification: 'Send email notification',
  sendToWhiteboard: 'Send to whiteboard',
  textFormattingHelp: 'Text formatting help',
  thePaymentHasBeenAcceptedForProcessingUsually:
    'The payment has been accepted for processing. Usually the payment is processed and credited, or canceled by the payment system/bank that has issued the card within 10—30 minutes. One should not make new payment attempts during this time.',
  thePaymentHasBeenCanceled: 'The payment has been canceled.',
  theTaskResultHasBeenApproved:
    'The task result has been approved by the quality control manager. Waiting for the client to rate and accept the result.',
  toSetUpTheInterfaceForTheRightWorkflow:
    'To set up the interface for the right workflow, we need to know a bit about you.',
  totalAmountOfImportedItems: 'Total amount of imported items',
  pleaseClickOnStarsToRateTheResult:
    'Please click on stars to rate the results and then Accept in case you are satisfied and want to download the final files',
  thisCommentWouldBeVisibleOnlyInTimeline:
    'This comment would be visible only in Timeline',
  thereIsNoBillingInfoInTheCompany: 'There is no billing info in the company.',
  youWillBeRedirectedToTheProjectPageIn:
    'You will be redirected to the project page in',
  youveSuccessfullyUnsubscribedFrom: 'You’ve successfully unsubscribed from',
  youveSuccessfullySubscribedTo: 'You’ve successfully subscribed to',
  youWontReceiveNotificationsFor: 'You won’t receive notifications for',
  youWillBeRedirectedToThePaymentsPageIn:
    'You will be redirected to the payments page in',
  startTypingToSearchForClients: 'Start typing to search for clients',
  studioEmbedId: 'Studio embed id',
  errorLoadingImage: 'Error loading image',
  thisActionWillAffect: 'This action will affect',
  thisActionWillAddARecordTo: 'This action will add a record to',
  updateCost: 'Update cost',
  updateDueDate: 'Update due date',
  pleaseWaitYourDownloadWillBeReadyInSeveralMinutes:
    'Please, wait. Your download will be ready in several minutes.',
  orChangeTableSettingsToAlwaysShowHiddenElements:
    'or change table settings to always show hidden elements.',
  hiddenAnd: 'hidden and',
  hereIsTheExampleOfWhatYoullGet: 'Here is the example of what you’ll get',
  notificationsForThisTaskAreNowDisabledExceptWhenYoureMentioned:
    "Notifications for this task are now disabled, except when you're mentioned.",
  notificationsForThisTaskAreNowEnabled:
    'Notifications for this task are now enabled.',
  notificationsForThisProjectAreNowDisabledExceptWhenYoureMentioned:
    "Notifications for this project are now disabled, except when you're mentioned.",
  notificationsForThisProjectAreNowEnabled:
    'Notifications for this project are now enabled.',
  beforeYouAcceptTheTaskWeLikeToRemindYouThat: `Before you accept the task, we'd like to remind you that:`,
  onceYouAcceptTheTaskItWillCloseAndYouWillNotBeAbleToLeaveNewCommentsInIt: `Once you accept the task, it will close and you won't be able to leave new comments in it.`,
  ifYouAreUnsureWhoToInviteNowYouCanSkip:
    'If you’re unsure who to invite now, you can skip this step, and we’ll help you add your team later.',
  ifYouWantTheResultTweakedOrAdjustedAfterThatItWillBeANewTaskAndChargedAccordingly:
    'If you want the result tweaked or adjusted after that, it will be a new task and charged accordingly.',
  imageUploadFailed: 'Image upload failed',
  pleaseRateResults: 'Please rate results',
  thereAreNoNonValidTasks: 'There are no non-valid tasks.',
  thereAreNoValidTasks: 'There are no valid tasks.',
  youCanAlwaysDownloadTheFilesToSeeThemOnYourDeviceBeforeAcceptingTheTask:
    'You can always download the files to see them on your device before accepting the task',
  linkToTheCRMaUsernameAndPasswordCombinationUsedForLoggingInToOnlineAccountEtc:
    'Link to the CRM, a username and password combination used for logging in to online account etc.',
  youAreAboutToChangeTheClientExistingTasksItemsWillBeDeletedAreYouSureYouWantToProceed:
    'You are about to change the client. Existing tasks items will be deleted. Are you sure you want to proceed?',
  pleaseAdjustYourFiltersAndTryAgainOr:
    'Please adjust your filters and try again or',
  noItemsMatchYourSearchCriteria: 'No items match your search criteria.',
  noRowsToShow: 'No rows to show',
  sorryNoItemsMatchYourSearchCriteria:
    'Sorry, no items match your search criteria.',
  letsCreateYourFirstProject: "Let's create your first project",
  letsDiveIn: "Let's dive in!",
  startByOutliningYourProjectVisionBe:
    'Start by outlining your project vision—be it for architecture, product prototyping, or virtual environments.',
  ourExpertTeamWillWorkCloselyWith:
    'Our expert team will work closely with you to transform your concepts into captivating 3D visuals.',
  hereIsABriefOfOurServicesAndPricesNo:
    "Here's a brief of our services and prices. No commitment now; adjust anytime.",
  unsureClickStartProjectAnd:
    'Unsure? Click "Start project", and we\'ll sort it out.',
  unlessYoureMentionedDirectly: "unless you're mentioned directly.",
  unableToSplitInvoicesOneOrMoreInvoicesAreAssignedToDifferentGeneralLedger:
    'Unable to split invoices: one or more invoices are assigned to a different General Ledger.',
  unableToStartTask: 'Unable to start task',
  itemsAssociatedWithDifferentLedgersInTheSmartContractAllItemsMustUseTheSameLedgerToContinuePleaseContactThePmOfThisTaskToResolveThisIssue:
    'Items are associated with different ledgers in the smart contract. All items must use the same ledger to continue. Please contact the PM of this task to resolve this issue.',
  asTeamMemberOf: 'as team member of:',
  generateApplicationToken1: 'Generate Application Token 1',
  generateApplicationToken2: 'Generate Application Token 2',
  refreshAccessToken: 'Refresh Access Token',
  remainAccessibleFor: ' remain accessible for ',
  reverseChargeForServices:
    'Reverse charge for services. Customer to account for the VAT.',
  yourPaymentIsBeingProcessedBeAdvisedThat:
    'Your payment is being processed. Be advised that the transaction may require 10 to 20 minutes to fully complete.',
  uploadASinglePhotoOfTheRoomAndOurAIWill:
    'Upload a single photo of the room, and our AI will detect the furniture pieces.',
  selectTheObjectYouWantToSearchInOur3DLibrary:
    'Select the object you want to search in our 3D library.',
  saveFieldInCompanyProfile: 'Save field in company profile',
  submitFilesWhenUploaded: 'Submit files when uploaded',
  searchForProductsOnYourImageUsingAI:
    'Search for products on your image using AI',
  theFunctionalityIsNotAvailableForSearchWithAI:
    'The functionality is not available for search with AI',
  thisAccountHasBeenDeletedPleaseContactSupport:
    'This account has been deleted. Please contact support.',
  uploadAPhotoOfARoomSelectACategory:
    'Upload a photo of a room, select a category in which you want to search, and our AI will find furniture items for you.',
  uploadedPercent: '{{progress}}% uploaded',
  theseFilesAreStoredInDeepArchiveBeforeDownloadingTheyMustFirstBeRestoredRestorationTypicallyTakesUpTo:
    'These files are stored in Deep Archive. Before downloading, they must first be restored. Restoration typically takes up to ',
  onceRestoredTheFilesWillBeAvailableForDownloadFor:
    '. Once restored, the files will be available for download for ',
  afterThisPeriodTheyWillReturnToDeepArchiveAndMustBeRestoredAgainToAccessThem:
    '. After this period, they will return to Deep Archive and must be restored again to access them.',
  selectedFilesHaveBeenSuccessfullyScheduledForRestoration:
    'Selected files have been successfully scheduled for restoration',
  restorationRequestAlreadySentEstimatedRestorationDate:
    'The restoration request has already been sent. Estimated restoration date:',
  restoreSelectedFiles: 'Restore selected files?',
  yesUnmuteEverything: 'Yes, unmute everything',
  yesMuteEverything: 'Yes, mute everything',
  wrapContent: 'Wrap Content',
  clipContent: 'Clip Content',
  uploadFailedPleaseRenameTheFileUsingLatinLettersOnly:
    'Upload failed. Please rename the file using Latin letters only.'
};
